import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const STORAGE_KEY = 'wosi-chat-guest-id';
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

@Injectable({ providedIn: 'root' })
export class ChatbotGuestService {
  private platformId = inject(PLATFORM_ID);
  private cached: string | null = null;

  getGuestId(): string | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    if (this.cached && UUID_RE.test(this.cached)) return this.cached;

    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (existing && UUID_RE.test(existing)) {
        this.cached = existing;
        return existing;
      }
    } catch {
      // quota / private mode
    }

    const created = globalThis.crypto?.randomUUID?.() ?? null;
    if (!created) return null;
    this.cached = created;
    try {
      localStorage.setItem(STORAGE_KEY, created);
    } catch {
      // ignore
    }
    return created;
  }

  headerValue(isLoggedIn: boolean): string | null {
    if (isLoggedIn) return this.getGuestId();
    return this.getGuestId();
  }
}
